// ============================================================
// 画像差し替え用の一元管理ファイル
// 各画像素材（ロゴ・キャラクター・商品写真・猪革・LINE QR）を
// ここでURLに差し替えるだけで、サイト全体に反映されます。
// ============================================================

export const images = {
  /** 株式会社MEGURI ロゴ */
  logo: "https://storage.helloreaddy.io/project_files/4a24ef4a-ce5d-4268-aaeb-a76be179fd73/9f0df244-dce8-43f7-a478-92f8e0db5998_compressed_S__71655639.webp",
  /** MEGURI カラフルイラスト（カエル×猪） */
  character: "https://storage.helloreaddy.io/project_files/4a24ef4a-ce5d-4268-aaeb-a76be179fd73/4b08b9b1-107b-4b07-9428-e93a1533cd28_compressed_S__71655629.webp",
  /** 商品写真① おすすめパック 5,000円（長崎県産猪肉／5000円パック） */
  product1: "https://storage.helloreaddy.io/project_files/4a24ef4a-ce5d-4268-aaeb-a76be179fd73/00276b68-8916-45f9-9a0f-b82198e72027_compressed_S__71688293.webp?nocache=true",
  /** 商品写真② おすすめパック 10,000円（箱に真空包装された猪肉） */
  product2: "https://storage.helloreaddy.io/project_files/4a24ef4a-ce5d-4268-aaeb-a76be179fd73/fa1e29cf-4047-435b-a006-1967a746f5da_compressed_S__71688294.webp?nocache=true",
  /** 商品写真③ ペット用猪肉（黒背景） */
  product3: "https://storage.helloreaddy.io/project_files/4a24ef4a-ce5d-4268-aaeb-a76be179fd73/8143a38d-8fd8-4620-bcc7-15c38ef0f8ad_compressed_S__71688287.webp?nocache=true",
  /** 商品写真④ ペット用鹿肉（鹿肉の画像） */
  product4: "https://storage.helloreaddy.io/project_files/4a24ef4a-ce5d-4268-aaeb-a76be179fd73/c6600239-3d7b-4e71-a225-05251dc91abd_compressed_S__71688295.webp?nocache=true",
  /** 猪革・レザー小物 写真 ① コレクション全体（縦長：レザー紹介ページ用） */
  leather1: "https://storage.helloreaddy.io/project_files/4a24ef4a-ce5d-4268-aaeb-a76be179fd73/f2f50377-a65c-4ce1-8f88-be8a18ab255e_compressed_S__71688208.webp",
  /** 猪革・レザー小物 写真 ② ロゴ入りレザー */
  leather2: "https://storage.helloreaddy.io/project_files/4a24ef4a-ce5d-4268-aaeb-a76be179fd73/02b13f97-7ab3-4510-a102-357ad24c4ddb_compressed_S__71688207.webp",
  /** LINE QRコード */
  lineQr: "https://storage.helloreaddy.io/project_files/4a24ef4a-ce5d-4268-aaeb-a76be179fd73/ed8111f7-e9fb-41bf-a9b0-5a03243f3703_compressed_S__71655641.webp",
};

export type ImageKey = keyof typeof images;